export default __webpack_public_path__ + "static/media/Betty Anderson.b049636c.mp3";